import {
    CircularGauge, Scale, Label, RangeContainer, ValueIndicator, Tick, MinorTick, SubvalueIndicator, Size,
} from 'devextreme-react/circular-gauge';
import {IpcCalcDTO} from "../../../../models/interfaces/dtos/ipc-calc-dto.ts";
import IpcKeyName from "../../../../models/enums/ipc-key-name.ts";
import formatDecimalNumber from '../../../../utils/format-decimal-number.ts';

type GaugeElementProps = {
    ipc: IpcCalcDTO | null;
}

const GaugeElement: React.FC<GaugeElementProps> = (
    {ipc}
) => {
    
    if(ipc == null) return (
        <div>Aucune données</div>
    )

    let color;
    if (ipc.keyName === IpcKeyName.CDF)
        color = ipc.value < ipc.targetValue ? "#4CAF50" : "#FFA726";
    else
        color = ipc.value > ipc.targetValue ? "#4CAF50" : "#FFA726";
    
    const isPercent = ipc.unity === "%";
    
    return (
        <div className="border bg-white border-gray-300 rounded-lg mb-4">
            <div className="flex gap-4 items-center">
                <div className="relative">
                    <CircularGauge value={ipc.value} subvalues={[ipc.targetValue]} id={`indicator-gauge-${ipc.keyName}`}>
                        <ValueIndicator type={"rangeBar"} color={color} backgroundColor="#DCDCDC"/>
                        <SubvalueIndicator color="#1E90FF" offset={25}/>

                        <Scale startValue={ipc.valueMin} endValue={ipc.valueMax}>
                            <Tick visible={false}/>
                            <MinorTick visible={false}/>
                            <Label visible={false}/>
                        </Scale>

                        <Size height={130} width={150}/>

                        <RangeContainer backgroundColor={"none"}/>
                    </CircularGauge>

                    <div className="absolute top-[50.5%] left-1/2 -translate-x-1/2">
                        <div className="text-[0.8rem]" style={{color: color}}>
                            {formatDecimalNumber(isPercent ? ipc.value * 100 : ipc.value)} {ipc.unity}
                        </div>

                    </div>

                    <div className="absolute bottom-[10%] left-1/2 -translate-x-1/2">
                        <div className="text-[0.8rem] text-blue-400">
                            {formatDecimalNumber((isPercent ? ipc.targetValue * 100 : ipc.targetValue))} {ipc.unity}
                        </div>
                    </div>
                </div>
                
                <div>
                    <div className="font-semibold">{ipc.title}</div>
                    {ipc.subTitle !== '' && <div className="text-sm text-gray-500">{ipc.subTitle}</div>}
                </div>
            </div>
        </div>
    )
}

export default GaugeElement;